// extracted by mini-css-extract-plugin
module.exports = {"bar":"scrollbar__bar___rNFl7"};